import { apiSlice } from './apiSlice';
import { AGENCY_URL } from '../constants';

export const agencyAuthApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    agencyLogin: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/auth`,
        method: 'POST',
        body: data, // { email, password }
      }),
    }),

    agencyLogout: builder.mutation({
      query: () => ({
        url: `${AGENCY_URL}/logout`,
        method: 'POST',
      }),
    }),

    agencyRequestPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/preset`,
        method: 'POST',
        body: data, // { email }
      }),
    }),

    agencyResetPassword: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/resetpass`,
        method: 'POST',
        body: data, // { email, password, resetToken }
      }),
    }),
  }),
});

export const {
  useAgencyLoginMutation,
  useAgencyLogoutMutation,
  useAgencyRequestPasswordResetMutation,
  useAgencyResetPasswordMutation,
} = agencyAuthApiSlice;
